import { useState } from 'react';
import { toast } from 'sonner';
import { useSetOnboardingVisibility } from '../../hooks/onboardingOps';
import { ApiError } from '../../lib/api';

export function OnboardingVisibilityPanel({
  personId,
  hidden,
}: {
  personId: string;
  hidden: boolean;
}) {
  const [isHidden, setIsHidden] = useState(hidden);
  const visibility = useSetOnboardingVisibility();

  async function toggle(next: boolean) {
    setIsHidden(next); // optimistic
    try {
      await visibility.mutateAsync({ personId, hidden: next });
    } catch (err) {
      setIsHidden(!next);
      toast.error(err instanceof ApiError ? err.message : 'Could not update');
    }
  }

  return (
    <section className="rounded-lg border border-line/10 bg-surface px-5 py-4 shadow-sm">
      <label className="flex items-start gap-2.5 text-sm">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={isHidden}
          disabled={visibility.isPending}
          onChange={(e) => toggle(e.target.checked)}
        />
        <span>
          <span className="font-semibold text-fg">Not an onboarding starter</span>
          <span className="mt-1 block text-xs text-fg-muted">
            Hides this person from the onboarding dashboard (they can still be shown via the "Hidden" toggle there). Use for induction-day-only attendees who don't need onboarding tasks.
          </span>
        </span>
      </label>
    </section>
  );
}
